export default {
  data () {
    return {
      showFixedTitle: false
    }
  },
  mounted () {
    this.titleScrollEvent()
  },
  methods: {
    titleScrollEvent () {
      window.addEventListener('scroll', () => {
        let top = document.documentElement.scrollTop
        if(top > 30 + 20 + 26){ // 30(上外边距) 20（上内边距）26(行高)
          this.showFixedTitle = true
        }else{
          this.showFixedTitle = false
        }
      })
    },
    scollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}